import React, { useEffect, useState } from 'react'
import AddLayout from '../../../../component/AddLayout'
import { Autocomplete, Box, Button, FormControl, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import dayjs from 'dayjs'
import DatePicker from '../../../../component/DatePicker'
import { addRawSeed, detailRawSeed, getItemMasterList, getItemRawBalanceList, getMaterialsList, getZones, updateRawSeed } from '../../services/api'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { GetBreedClassNo, GetSeasonNo } from '../../../stock/services/stockService'
import ConfirmDialog from '../component/ConfirmDialog'
import PintButton from '../../../../component/PintButton'
import ConfirmPrint from '../component/ConfirmPrint'
import { getData } from '../../../../services/api'
import api from '../../../../api/api'
import Swal from 'sweetalert2'

export default function PaidForMarketingDatail() {
  const { profile, loading } = useSelector(state => state.profile)
  const { id } = useParams()
  const location = useLocation();

  const navigate = useNavigate();
  const [refNoError, setRefNoError] = useState(false)
  const [senderOrReceiver, setSenderOrReceiver] = useState('งานตลาด')
  const [source, setSource] = useState('')
  const [documentDate, setDocumentDate] = useState(dayjs(new Date()))
  const [items, setItems] = useState([])
  const [materials, setMaterials] = useState([])
  const [branchs, setBranchs] = useState([])
  const [name, setName] = useState('')
  const [open, setOpen] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [documentType, setDocumentType] = useState('จ่าย');
  const [seedType, setSeedType] = useState('หลังปรับปรุง');
  const [loadingPDF, setLoadingPDF] = useState(false);
  const [detail, setDetail] = useState()
  const [openPint, setOpenPint] = useState(false)

  const [rows, setRows] = useState([
    {
      RefNo: "",
      ItemNo: null,
      Year: 0,
      Lot: "",
      MaterialNo: "",
      MaterialQty: 0,
      Qty: 0,
      WarehouseNo: "",
      ZoneNo: "",
      Remark: ""
    }
  ]);
  function addRow() {
    const newRow = {
      RefNo: "",
      ItemNo: null,
      Year: 0,
      Lot: "",
      MaterialNo: "",
      MaterialQty: 0,
      Qty: 0,
      WarehouseNo: "",
      ZoneNo: "",
      Remark: ""
    };

    setRows([...rows, newRow]);
  }
  const deletehand = (i) => {
    const data = rows?.filter((e, index) => i !== index);
    setRows(data);
  };
  const getDetail = async () => {
    const data = await detailRawSeed(id)
    setDetail(data)
    setDocumentDate(dayjs(data?.DocumentDate))
    setDocumentType(data?.DocumentType)
    setSeedType(data?.SeedType)
    setSource(data?.Source)
    setSenderOrReceiver(data?.SenderOrReceiver)
    setRows(data.Details)
  }
  useEffect(() => {
    
    getDetail()
  }, [id])
  useEffect(() => {
    const getZonesList = async () => {
      const data = await getZones(profile?.BranchNo?.BranchNo)
      setBranchs(data)
    }
    getZonesList()
  }, [profile])

  useEffect(() => {

    const getItemMaterials = async () => {
      const data = await getItemMasterList()
      setItems(data)
    }
    const getItemRawBalance = async () => {
      const data = await getItemRawBalanceList(profile?.BranchNo?.BranchNo, seedType)
      setItems(data)
    }
    if (documentType === 'รับ') {
      getItemMaterials()
    } else {
      getItemRawBalance()
    }


  }, [documentType])
  useEffect(() => {
    if (location?.state?.new) {
      setOpenPint(true)
    }
  }, [location?.state?.new])
  useEffect(() => {
    const getMaterials = async () => {
      const data = await getMaterialsList()
      setMaterials(data)
    }
    getMaterials()
  }, [])
  const handleSubmit = (index) => {
    setLoadingSubmit(true)

    const body = {
      DocumentNo: id,
      DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
      DocumentType: documentType,
      BranchNo: profile?.BranchNo?.BranchNo,
      SenderOrReceiver: senderOrReceiver,
      Source: source,
      SeedCategory: seedType,
      Status: index,
      Details: rows?.map((x) => (
        {

          RefNo: x?.RefNo,
          ItemNo: x?.ItemNo?.ItemNo,
          Year: x?.Year,
          Lot: x?.Lot,
          MaterialNo: x?.MaterialNo?.ItemNo,
          MaterialQty: +x?.MaterialQty.toString().replaceAll(',', ''),
          Qty: +x?.Qty.toString().replaceAll(',', ''),
          WarehouseNo: x?.WarehouseNo?.WarehouseNo,
          ZoneNo: x?.ZoneNo?.ZoneNo,
          Remark: x?.Remark
        }
      ))
    }
    const put = async () => {

      const res = await updateRawSeed(body)
      if (res) {
        setLoadingSubmit(false)
        setOpen(false)
        if (body.Status !== 'N') {
          setOpenPint(true)
          getDetail()
        } else {
          Swal.fire(
            'ยกเลิกรายการสำเร็จ',
            '',
            'success'
          )
          getDetail()
        }
      }
    }
    put()
  }
  async function download() {
    setLoadingPDF(true)
    const res = await api.get('raw-seed/movements' + `/${id}/pdf`, {
      responseType: 'arraybuffer'
    })
    const buffer = res.data
    const blob = new Blob([buffer], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    window.open(url, '_blank');
    setLoadingPDF(false)
  }
  const inputHead = [
    {
      name: 'วันที่ทำรายการ',
      inputComponent: <><DatePicker value={documentDate} onChange={e => setDocumentDate(e)} disabled={false} /></>,
    },
    {
      name: '',
      inputComponent: <></>,
    },
    {
      name: 'จ่ายให้',
      inputComponent: <>
        <Box className={`backgroundField ${refNoError ? 'error' : ''}`} sx={{ marginBottom: '10px' }}>
          <TextField required value={senderOrReceiver}
            // onBlur={e => {
            //     if (!e.target.value) {
            //         setRefNoError(true)
            //     } else {
            //         setRefNoError(false)
            //     }
            // }} 
            disabled
            onChange={e => setSenderOrReceiver(e.target.value)} variant="standard" fullWidth
            InputProps={{
              disableUnderline: true,
            }}
          />
        </Box>
        {/* <RequireField value={senderOrReceiver} onChange={setSenderOrReceiver} type={'text'} disabled={false} error={refNoError} setError={setRefNoError} textError={'กรุณาที่รับ'} /> */}
      </>,
    },
    {
      name: '',
      inputComponent: <>

      </>,

    },
    {
      name: <><label class="labelInput">ผู้สร้าง</label><label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/YYYY')} )</label>  </>,
      inputComponent: <>
        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
          <TextField value={detail?.CreateId} variant="standard" fullWidth disabled={id ? true : false}
            InputProps={{
              disableUnderline: true,
              readOnly: true
            }}
          />
        </Box>
      </>,
    },
    {
      name: <><label class="labelInput">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/YYYY')} )</label></>,
      inputComponent: <>
        <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
          <TextField value={detail?.ModifiedId} variant="standard" fullWidth disabled={id ? true : false}
            InputProps={{
              disableUnderline: true,
              readOnly: true
            }}
          />
        </Box>
      </>,
    },

  ]
  const head = [
    'เลขที่อ้างอิง',
    'เมล็ดพันธุ์',
    'ชั้นพันธุ์',
    'ฤดู',
    'ปีที่ผลิต',
    'ล็อตที่',
    'ประเภทบรรจุภัณฑ์',
    'จำนวน (กระสอบ)',
    'ปริมาณ (กิโลกรัม)',
    'ปริมาณเฉลี่ย/กระสอบ',
    'โรงเก็บที่',
    'หมายเหตุ',
    ''
  ]
  const body = rows?.map((x, i) => {

    return {
      item1: <TextField value={x?.RefNo || ''}
        sx={{ background: '#fff', width: '150px' }}
        size='small' fullWidth variant='outlined'
        onChange={e => {
          const item = rows?.map((v, index) => {
            v.RefNo = index === i ? e.target.value : v?.RefNo;
            return v;

          });
          setRows(item);
        }}
      />,
      item2: <>
        <Autocomplete
          size='small'
          options={items}
          readOnly={id ? true : false}
          getOptionLabel={(option) => option?.ItemName}
          onBlur={e => {
            const item = rows?.map((v, index) => {
              v.LotError = index === i ? x.ItemNo ? false : true : v?.LotError;
              return v;
            });
            setRows([...item]);
          }
          }
          componentsProps={{
            paper: {
              sx: {
                width: 500
              }
            }
          }}
          renderOption={(props, option) => (
            <Box component="li" {...props} key={option.ItemNo}>
              {option?.CatalogNo?.CatalogName} {option?.Option2} <span style={{ color: option?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.Option1}
            </Box>
          )}
          value={x?.ItemNo}
          onChange={(event, newValue) => {
            const item = rows?.map((v, index) => {
              v.LotGen = index === i ? null : v?.LotGen;
              v.ItemNo = index === i ? newValue : v?.ItemNo;
              return v;

            });
            setRows([...item]);

          }}

          renderInput={(params) => (
            <Box ref={params.InputProps.ref}>
              <OutlinedInput error={!x?.LotError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: id ? '#e9ecef' : '#fff' }} />
            </Box>
          )}
        />
      </>,
      item3: x?.ItemNo?.Option2,
      item4: <span style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}</span>,
      item5: <><TextField className='w-70' error={!x?.YearError ? false : true} onBlur={e => {
        const item = rows?.map((v, index) => {
          v.YearError = index === i ? x.Year ? false : true : v?.YearError;
          return v;

        });
        setRows([...item]);
      }
      } value={x?.Year}
        size='small' variant='outlined'
        InputProps={{
          disableUnderline: true,
          readOnly: true
        }}
        sx={{ background: '#e9ecef' }}
        inputProps={{ maxLength: 2 }}
        onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }} />
      </>,
      item6: <div style={{ position: "relative" }}>
        <Box sx={{
          display: 'flex', '& .MuiTextField-root': {
            color: 'red',
            '& .MuiOutlinedInput-root': { borderRadius: '0 .25rem .25rem 0' }
          }
        }}>

          <TextField sx={{ background: '#e9ecef', width: "150px" }}
            InputProps={{
              disableUnderline: true,
              readOnly: true
            }}
            onBlur={e => {
              const item = rows?.map((v, index) => {
                v.LotGenError = index === i ? x.Lot.length === 3 ? false : true : v?.LotGenError;
                return v;

              });
              setRows([...item]);
            }} value={x?.Lot}
            inputProps={{ maxLength: 3 }}
            size='small' fullWidth variant='outlined' onChange={e => {
              const item = rows?.map((v, index) => {
                v.Lot = index === i ? e.target.value : v?.Lot;
                return v;

              });
              setRows([...item]);
            }} onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }} />

        </Box>
        {/* {!x?.LotGenError || lastLot ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-16px' }}>กรุณากรอกเลขล็อต</span>} 
  {lastLot && <span style={{ fontSize: '12px', position: 'absolute', bottom: '-20px' }}>{`Lotล่าสุด  ${lastLot}`}</span>}
   */}
      </div>,
      item7: x?.MaterialNo?.ItemName
      // <FormControl className='w-120' sx={{ background: '#e9ecef' }} variant="outlined" size='small' fullWidth
      //   error={x?.MaterialNoError}
      //   readOnly
      // >
      //   <Select value={x?.MaterialNo?.ItemNo || ''} readOnly >
      //     {materials?.map((z, i) => {
      //       return (
      //         <MenuItem key={i} value={z?.ItemNo}>{z?.ItemName}</MenuItem>
      //       )
      //     })}
      //   </Select>
      // </FormControl>
      ,
      item8: x?.MaterialQty
      // <TextField value={x?.MaterialQty.toLocaleString()}
      //   sx={{ background: '#e9ecef', width: "120px" }}
      //   InputProps={{
      //     disableUnderline: true,
      //     readOnly: true
      //   }}
      //   type='tel' size='small' fullWidth variant='outlined' onChange={e => {
      //     let newValue = e.target.value.replace(/,/g, "");

      //     let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      //     const item = rows?.map((v, index) => {
      //       v.MaterialQty = i === index ? abc : v?.MaterialQty;
      //       v.OtyPer = i === index ? +x?.Qty?.toString().replaceAll(',', '') / +e.target.value.toString().replaceAll(',', '') : v?.OtyPer
      //       return v;

      //     });
      //     setRows([...item]);
      //   }} onKeyPress={(event) => {
      //     if (!/[0-9]/.test(event.key)) {
      //       event.preventDefault();
      //     }
      //   }} />
      ,
      item9: <TextField value={x?.Qty.toLocaleString()}
        sx={{ background: '#e9ecef', width: "120px" }}
        InputProps={{
          disableUnderline: true,
          readOnly: true
        }}
        type='tel' size='small' fullWidth variant='outlined' onChange={e => {
          let newValue = e.target.value.replace(/,/g, "");

          let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          const item = rows?.map((v, index) => {
            v.OtyPer = i === index ? +e.target.value.toString().replaceAll(',', '') / +x?.MaterialQty.toString().replaceAll(',', '') : v?.OtyPer
            v.Qty = i === index ? abc : v?.Qty;
            return v;

          });
          setRows([...item]);
        }} onKeyPress={(event) => {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        }} />,
      item10: (+x?.Qty / +x?.MaterialQty)?.toFixed(2),
      item11: <> <FormControl className='w-120' variant="outlined" size='small' fullWidth
        error={x?.WarehouseError}
        sx={{ background: '#e9ecef' }}

      >
        <Select value={x?.ZoneNo?.ZoneNo || ''} readOnly
        >
          {/* <MenuItem value='all' disabled>เลือกโรงเก็บ</MenuItem> */}
          {branchs?.map((z, i) => (
            <MenuItem value={z?.ZoneNo}>{z?.WarehouseNo?.WarehouseName} {z?.ZoneName}</MenuItem>
          ))}
        </Select>
      </FormControl>
      </>,
      item12: <TextField sx={{ width: '150px' }} value={x?.Remark} size='small' fullWidth variant='outlined' onChange={e => {

        const item = rows?.map((v, index) => {
          v.Remark = i === index ? e.target.value : v?.Remark;
          return v;

        });
        setRows([...item]);
      }}
      />,
      item13: null,
    }
  })
  return (
    <AddLayout
      title={'รายการจ่ายให้งานตลาด'}
      action={
        <PintButton loading={loadingPDF} download={download} />
      }
      inputHead={inputHead}
      inputRemark={null}
      bodyTitle={'รายการจ่ายให้งานตลาด'}
      bodyAction={null}
      tableHead={head}
      tableBody={body}
      bootomAction={<>
        <Button onClick={() => navigate(location?.state?.new ? -2 : -1)} variant='outlined'
          startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
          sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
        {detail?.Status !== 'N' && <><Button variant='contained' onClick={() => setOpen(true)} sx={{ width: '130px', fontSize: '14px' }}>แก้ไข</Button>
          <Button variant='contained' onClick={() => {
            Swal.fire({
              title: 'ยืนยันการยกเลิก',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#4ab866',
              cancelButtonColor: '#d33',
            }).then((result) => {
              if (result.isConfirmed) {
                handleSubmit('N')
              }
            })
          }} color='error' type='submit' sx={{ width: '130px', fontSize: '14px', marginLeft: '10px' }}>ยกเลิก</Button></>}
      </>}
      dialog={<>
        <ConfirmDialog open={open} setOpen={setOpen} rows={rows} handleSubmit={handleSubmit} loadingSubmit={loadingSubmit} />
        <ConfirmPrint title={'บันทึกรายการจ่ายให้งานตลาดสำเร็จ'} download={download} open={openPint} setOpen={setOpenPint} loadingPDF={loadingPDF} linkTo='/raw/paidformarketing/add' />
      </>
      } />
  )
}
